// import { React, useState, useEffect, useRef } from "react";
// import { PipeDesign, TableLayoutData } from "../../Pages/styledElements";
// import { TableList, RadioButtonStyle } from "../../Pages/pageStyled";
// import { HaberForm } from "../../Pages/styledElements";
// import Iconmoon from "../IconsFiles/icon";
// import { Radio, Table, Tooltip } from "antd";
// import moment from "moment";
// import SheetJobCardCylinder from "./SheetJobCardCylinder";
// import {
//   CoversionFactorCMToUnits,
//   CoversionFactorUnitsToCM,
//   currency_List,
//   lengthUnit,
//   weightUnit,
// } from "../../Utils/Constant/MeasurementUnitList.jsx";
// import SheetJobCardCylinderMultistage from "./SheetJobCardCylinderMultistage.jsx";
// import { mergeCuttingPlans } from "../../Utils/helper/helper.js";

// function onChange(pagination, filters, sorter, extra) {
//   console.log("params", pagination, filters, sorter, extra);
// }
// const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

// const SheetJobCardCylinderContainerMultistage = ({
//   // cylinderData,
//   jobId,
//   solution,
//   multiView,
//   deckle_match_page = false,
//   print_function = null,
//   acceptedSolution,
//   jobCard,
//   unitData,
//   isTabularView = false,
//   isValidState = false,
//   reFetchToggle,
//   cylinderViewData
// }) => {
//   const [gridView, setGridView] = useState(true);
//   const [cylinderData, setCylinderData] = useState();
//   const [reFetch, setReFetch] = useState(false);
//   const [dataSet, setDataSet] = useState([]);

//   function calculateDeckleSize(job, isCylinder, sheet) {
//     const machine = sheet
//       ? job?.group?.machines[1]
//       : job?.jobcard?.group?.machines[0];

//     if (machine) {
//       const deckleSizeUB = machine?.deckle_size_ub || 0;
//       const leftEdgeTrim = machine?.left_edge_trim || 0;
//       const rightEdgeTrim = machine?.right_edge_trim || 0;

//       const lengthUnitDisplayName =
//         lengthUnit[machine?.units?.deckle_size_ub]?.displayName || "";

//       const totalValue =
//         (
//           deckleSizeUB +
//           (leftEdgeTrim + rightEdgeTrim) *
//             CoversionFactorUnitsToCM[machine?.units?.right_edge_trim] *
//             CoversionFactorCMToUnits[machine?.units?.deckle_size_ub]
//         );

//       const deckleSizeLB = machine?.deckle_size_lb || 0;

//       let formattedTotalValue;
//       if (Number.isInteger(totalValue)) {
//         formattedTotalValue = totalValue?.toFixed(0); // Convert to integer
//       } else {
//         formattedTotalValue = totalValue?.toFixed(3); // Show up to 3 decimal places
//       }
//       let formattedLB = Number.isInteger(deckleSizeLB) ? deckleSizeLB : deckleSizeLB?.toFixed(3);
//       return isCylinder
//         ? `${formattedLB} - ${formattedTotalValue} ${lengthUnitDisplayName}`
//         : `${formattedTotalValue} - ${formattedLB} ${lengthUnitDisplayName}`;
//     }

//     return "";
// }


//   useEffect(() => {
//     if(cylinderViewData==='production'){
//     let data = acceptedSolution?.data ? mergeCuttingPlans(acceptedSolution?.data?.cutting_patterns) : null;
//     let mergedData = acceptedSolution?.data ? { ...acceptedSolution?.data, cutting_patterns: data } : null;
//     setCylinderData(mergedData);
//     }
//     else{
//       setCylinderData(acceptedSolution?.data);
//     }
    
//   },[acceptedSolution,cylinderViewData])
//   useEffect(() => {
//     if (reFetchToggle) reFetchToggle();
//   }, [reFetch]);
//   const solutionId =
//     solution == 1 ? "solution_1" : solution == 2 ? "solution_2" : null;

//   useEffect(() => {
//     setGridView(!isTabularView);
//   }, [isTabularView]);

//   const cylinderColumnHead = [
//     {
//       title: "Reel Size",
//       dataIndex: "reel_size",
//       width: "0.02%",
//       align: "center",
//     },
//     {
//       title: "No. of Reels",
//       dataIndex: "no_of_reels",
//       width: "0.02%",
//       align: "center",
//     },
//     {
//       title: "Reel Dia",
//       dataIndex: "reel_dia",
//       width: "0.02%",
//       align: "center",
//     },
//     {
//       title: "Com No.",
//       dataIndex: "combination_number",
//       width: "0.02%",
//       align: "center",
//     },
//     {
//       title: "Edge Trim (L)",
//       dataIndex: "left_edge_trim",
//       width: "0.02%",
//       align: "center",
//     },
//     {
//       title: "Partition",
//       dataIndex: "cutting_pattern",
//       width: "0.01%",
//       align: "center",
//     },
//     {
//       title: "D. Com Width",
//       dataIndex: "d_com_width",
//       width: "0.01%",
//       align: "center",
//     },
//     {
//       title: "Trim",
//       dataIndex: "trim",
//       width: "0.01%",
//       align: "center",
//     },
//     {
//       title: "Edge Trim (R)",
//       dataIndex: "right_edge_trim",
//       width: "0.02%",
//       align: "center",
//     },
//     {
//       title: "Rewinding Pattern",
//       dataIndex: "rewinding_pattern",
//       width: "0.02%",
//       align: "center",
//     },
//     {
//       title: "Del Date",
//       dataIndex: "deldate",
//       width: "0.1%",
//       align: "center",
//     },
//     {
//       title: "Weight",
//       dataIndex: "weight",
//       width: "0.01%",
//       align: "center",
//     },
//   ];
//   useEffect(() => {
//     if (!cylinderData) return;
//     setDataSet(
//       cylinderData?.cutting_patterns?.map((item, index) => {
//         let totalWidth = 0;
//         let totalWeight = item?.total_weight;
//         item?.cutting_partitions.forEach((current) => {
//           totalWidth = totalWidth + current.size;
//           // totalWeight = totalWeight + current.weight;
//           //ordersToShowInTable[+(index + 1)] = current?.size
//         });
//         const cuttingPattern =
//           "(" +
//           item?.cutting_partitions?.map((item) => item?.size).join("+") +
//           ") x " +
//           item?.length +
//           " " +
//           (item?.units?.length
//             ? lengthUnit[item?.units?.length]?.displayName
//             : "cm");
//         const rewindingPattern =
//           item?.rewinder_code +
//           "\n" +
//           "Com. No.: " +
//           [
//             ...new Set(
//               item?.combination_position?.map((combi) => combi?.combination)
//             ),
//           ];
//         let ordersToShowInTable = {
//           key: index + 1,
//           total:
//             totalWidth +
//             (item?.units ? " " + lengthUnit[item?.units?.size]?.displayName : ""),
//           trim:
//             item?.trim_loss +
//             (item?.units
//               ? " " + lengthUnit[item?.units?.trim_loss]?.displayName
//               : " cm"),
//           deldate: moment(item?.cutting_partitions?.[0]?.deadline).format(
//             "DD MMM YYYY"
//           ),
//           weight:
//             (totalWeight-item?.cancelled_weight).toFixed(3) +
//             (item?.units
//               ? " " + capitalize(weightUnit[item?.units?.weight]?.displayName)
//               : " T"),
//           reel_size:
//             item?.reel_size +
//             (item?.units?.reel_size
//               ? " " + lengthUnit[item?.units?.reel_size]?.displayName
//               : " cm"),
//           no_of_reels: item?.no_of_reels,
//           reel_dia:
//             item?.reel_dia +
//             (item?.units?.reel_dia
//               ? " " + lengthUnit[item?.units?.reel_dia]?.displayName
//               : " cm"),
//           left_edge_trim:
//             item?.left_edge_trim +
//             (item?.units?.left_edge_trim
//               ? " " + lengthUnit[item?.units?.left_edge_trim]?.displayName
//               : " cm"),
//           right_edge_trim:
//             item?.right_edge_trim +
//             (item?.units?.right_edge_trim
//               ? " " + lengthUnit[item?.units?.right_edge_trim]?.displayName
//               : " cm"),
//           combination_number: item?.cutting_combination_no,
//           cutting_pattern: cuttingPattern,
//           rewinding_pattern: rewindingPattern,
//           d_com_width:
//             totalWidth +
//             (item?.units ? " " + lengthUnit[item?.units?.size]?.displayName : ""),
//         };
//         return ordersToShowInTable;
//       })
//     );
//   }, [cylinderData]);

//   return jobId && cylinderData ? (
//     <>
//       {" "}
//       <p
//         style={{
//           display: "flex",
//           width: "100%",
//           color: "black",
//           fontSize: "14px",
//           marginTop: "30px",
//           padding: "0 10px",
//           fontFamily: "var(--sf-pro-display-m)",
//         }}
//       >
//         <span style={{ width: "50%" }}>
//           Cutter:{" "}
//           {
//             jobCard?.group?.machines?.filter(
//               (item) => item?.machine_type === "cutter"
//             )[0]?.cutter_name
//           }
//         </span>
//         <span style={{ width: "50%", textAlign: "right" }}>
//           Deckle:{" "}
//           {calculateDeckleSize(jobCard, true, true)}
//         </span>
//       </p>
//       <PipeDesign>
//         <div className="main-container">
//           {gridView ? (
//             cylinderData &&
//             (cylinderData?.cutting_patterns?.length ? (
//               <div style={{ width: "100%" }}>
//                 <SheetJobCardCylinderMultistage
//                   currentCylinderData={cylinderData?.cutting_patterns}
//                   multiview={multiView}
//                   jobCard={jobCard}
//                   unitData={unitData}
//                   isSingleCylinder={false}
//                   isValidState={isValidState}
//                   jobId={jobId}
//                   reFetchToggle={() => setReFetch(!reFetch)}
//                   acceptedSolution={solution}
//                   cylinderViewData={cylinderViewData}
//                 />
//               </div>
//             ) : (
//               <p style={{width: '100%', textAlign: 'center'}}> <span>There are no cutting patterns in this job card.</span> </p>
//             ))
//           ) : (
//             <div className="list-grid-view">
//               <TableLayoutData>
//                 <div className="tableDataFormat removePagnation">
//                   {cylinderData?.cutting_patterns?.length ? (
//                     <Table
//                       size="large"
//                       style={{
//                         minWidth: "100% !important",
//                         width: "100% !important",
//                       }}
//                       columns={cylinderColumnHead}
//                       dataSource={dataSet}
//                       onChange={onChange}
//                       scroll={{
//                         x: window.screen.width < 1500,
//                       }}
//                       pagination={false}
//                     />
//                   ) : (
//                     <p style={{width: '100%', textAlign: 'center'}}>
//                       <span> There are no cutting patterns in this job card.</span> 
//                     </p>
//                   )}
//                 </div>
//               </TableLayoutData>
//             </div>
//           )}
//         </div>
//       </PipeDesign>
//     </>
//   ) : null;
// };

// export default SheetJobCardCylinderContainerMultistage;


import { React, useState, useEffect, useRef } from "react";
import { PipeDesign, TableLayoutData } from "../../Pages/styledElements";
import { TableList, RadioButtonStyle } from "../../Pages/pageStyled";
import { HaberForm } from "../../Pages/styledElements";
import Iconmoon from "../IconsFiles/icon";
import { Radio, Table, Tooltip } from "antd";
import moment from "moment";
import SheetJobCardCylinder from "./SheetJobCardCylinder";
import {
  CoversionFactorCMToUnits,
  CoversionFactorUnitsToCM,
  currency_List,
  lengthUnit,
  weightUnit,
} from "../../Utils/Constant/MeasurementUnitList.jsx";
import SheetJobCardCylinderMultistage from "./SheetJobCardCylinderMultistage.jsx";
import { mergeCuttingPlans } from "../../Utils/helper/helper.js";

function onChange(pagination, filters, sorter, extra) {
  console.log("params", pagination, filters, sorter, extra);
}
const capitalize = (item) => item?.charAt(0).toUpperCase() + item?.slice(1);

const SheetJobCardCylinderContainerMultistage = ({
  // cylinderData,
  jobId,
  solution,
  multiView,
  deckle_match_page = false,
  print_function = null,
  acceptedSolution,
  jobCard,
  unitData,
  isTabularView = false,
  isValidState = false,
  reFetchToggle,
  cylinderViewData
}) => {
  const [gridView, setGridView] = useState(true);
  const [cylinderData, setCylinderData] = useState();
  const [reFetch, setReFetch] = useState(false);
  const [dataSet, setDataSet] = useState([]);

  function calculateDeckleSize(job, isCylinder, sheet) {
    const machine = sheet
      ? job?.group?.machines[1]
      : job?.jobcard?.group?.machines[0];

    if (machine) {
      const deckleSizeUB = machine.deckle_size_ub || 0;
      const leftEdgeTrim = machine.left_edge_trim || 0;
      const rightEdgeTrim = machine.right_edge_trim || 0;

      const lengthUnitDisplayName =
        lengthUnit[machine.units?.deckle_size_ub]?.displayName || "";

      const totalValue =
        (
          deckleSizeUB +
          (leftEdgeTrim + rightEdgeTrim) *
            CoversionFactorUnitsToCM[machine.units?.right_edge_trim] *
            CoversionFactorCMToUnits[machine.units?.deckle_size_ub]
        );

      const deckleSizeLB = machine.deckle_size_lb || 0;

      let formattedTotalValue;
      if (Number.isInteger(totalValue)) {
        formattedTotalValue = totalValue.toFixed(0); // Convert to integer
      } else {
        formattedTotalValue = totalValue.toFixed(3); // Show up to 3 decimal places
      }
      let formattedLB = Number.isInteger(deckleSizeLB) ? deckleSizeLB : deckleSizeLB?.toFixed(3);
      return isCylinder
        ? `${formattedLB} - ${formattedTotalValue} ${lengthUnitDisplayName}`
        : `${formattedTotalValue} - ${formattedLB} ${lengthUnitDisplayName}`;
    }

    return "";
}


  useEffect(() => {
    if(cylinderViewData==='production'){
    let data = acceptedSolution?.data ? mergeCuttingPlans(acceptedSolution.data?.cutting_patterns) : null;
    let mergedData = acceptedSolution?.data ? { ...acceptedSolution.data, cutting_patterns: data } : null;
    setCylinderData(mergedData);
    }
    else{
      setCylinderData(acceptedSolution?.data);
    }
    
  },[acceptedSolution,cylinderViewData])
  useEffect(() => {
    if (reFetchToggle) reFetchToggle();
  }, [reFetch]);
  const solutionId = `solution_${solution}`
  useEffect(() => {
    setGridView(!isTabularView);
  }, [isTabularView]);

  const cylinderColumnHead = [
    {
      title: "Reel Size",
      dataIndex: "reel_size",
      width: "0.02%",
      align: "center",
    },
    {
      title: "No. of Reels",
      dataIndex: "no_of_reels",
      width: "0.02%",
      align: "center",
    },
    {
      title: "Reel Dia",
      dataIndex: "reel_dia",
      width: "0.02%",
      align: "center",
    },
    {
      title: "Com No.",
      dataIndex: "combination_number",
      width: "0.02%",
      align: "center",
    },
    {
      title: "Edge Trim (L)",
      dataIndex: "left_edge_trim",
      width: "0.02%",
      align: "center",
    },
    {
      title: "Partition",
      dataIndex: "cutting_pattern",
      width: "0.01%",
      align: "center",
    },
    {
      title: "D. Com Width",
      dataIndex: "d_com_width",
      width: "0.01%",
      align: "center",
    },
    {
      title: "Trim",
      dataIndex: "trim",
      width: "0.01%",
      align: "center",
    },
    {
      title: "Edge Trim (R)",
      dataIndex: "right_edge_trim",
      width: "0.02%",
      align: "center",
    },
    {
      title: "Rewinding Pattern",
      dataIndex: "rewinding_pattern",
      width: "0.02%",
      align: "center",
    },
    {
      title: "Del Date",
      dataIndex: "deldate",
      width: "0.1%",
      align: "center",
    },
    {
      title: "Weight",
      dataIndex: "weight",
      width: "0.01%",
      align: "center",
    },
  ];
  useEffect(() => {
    if (!cylinderData) return;
    setDataSet(
      cylinderData.cutting_patterns?.map((item, index) => {
        let totalWidth = 0;
        let totalWeight = item?.total_weight;
        item.cutting_partitions.forEach((current) => {
          totalWidth = totalWidth + current.size;
          // totalWeight = totalWeight + current.weight;
          //ordersToShowInTable[+(index + 1)] = current?.size
        });
        const cuttingPattern =
          "(" +
          item.cutting_partitions.map((item) => item.size).join("+") +
          ") x " +
          item.length +
          " " +
          (item.units?.length
            ? lengthUnit[item.units?.length]?.displayName
            : "cm");
        const rewindingPattern =
          item?.rewinder_code +
          "\n" +
          "Com. No.: " +
          [
            ...new Set(
              item?.combination_position.map((combi) => combi.combination)
            ),
          ];
        let ordersToShowInTable = {
          key: index + 1,
          total:
            totalWidth +
            (item.units ? " " + lengthUnit[item.units.size].displayName : ""),
          trim:
            item.trim_loss +
            (item.units
              ? " " + lengthUnit[item.units.trim_loss].displayName
              : " cm"),
          deldate: moment(item.cutting_partitions[0].deadline).format(
            "DD MMM YYYY"
          ),
          weight:
            (totalWeight-item?.cancelled_weight).toFixed(3) +
            (item.units
              ? " " + capitalize(weightUnit[item.units.weight].displayName)
              : " T"),
          reel_size:
            item?.reel_size +
            (item.units?.reel_size
              ? " " + lengthUnit[item.units.reel_size].displayName
              : " cm"),
          no_of_reels: item?.no_of_reels,
          reel_dia:
            item?.reel_dia +
            (item.units?.reel_dia
              ? " " + lengthUnit[item.units.reel_dia].displayName
              : " cm"),
          left_edge_trim:
            item?.left_edge_trim +
            (item.units?.left_edge_trim
              ? " " + lengthUnit[item.units.left_edge_trim].displayName
              : " cm"),
          right_edge_trim:
            item?.right_edge_trim +
            (item.units?.right_edge_trim
              ? " " + lengthUnit[item.units.right_edge_trim].displayName
              : " cm"),
          combination_number: item?.cutting_combination_no,
          cutting_pattern: cuttingPattern,
          rewinding_pattern: rewindingPattern,
          d_com_width:
            totalWidth +
            (item.units ? " " + lengthUnit[item.units.size].displayName : ""),
        };
        return ordersToShowInTable;
      })
    );
  }, [cylinderData]);

  return jobId && cylinderData ? (
    <>
      {" "}
      <p
        style={{
          display: "flex",
          width: "100%",
          color: "black",
          fontSize: "14px",
          marginTop: "30px",
          padding: "0 10px",
          fontFamily: "var(--sf-pro-display-m)",
        }}
      >
        <span style={{ width: "50%" }}>
          Cutter:{" "}
          {
            jobCard?.group.machines?.filter(
              (item) => item.machine_type === "cutter"
            )[0]?.cutter_name
          }
        </span>
        <span style={{ width: "50%", textAlign: "right" }}>
          Deckle:{" "}
          {calculateDeckleSize(jobCard, true, true)}
        </span>
      </p>
      <PipeDesign>
        <div className="main-container">
          {gridView ? (
            cylinderData &&
            (cylinderData?.cutting_patterns?.length ? (
              <div style={{ width: "100%" }}>
                <SheetJobCardCylinderMultistage
                  currentCylinderData={cylinderData?.cutting_patterns}
                  multiview={multiView}
                  jobCard={jobCard}
                  unitData={unitData}
                  isSingleCylinder={false}
                  isValidState={isValidState}
                  jobId={jobId}
                  reFetchToggle={() => setReFetch(!reFetch)}
                  acceptedSolution={solution}
                  cylinderViewData={cylinderViewData}
                />
              </div>
            ) : (
              <p style={{width: '100%', textAlign: 'center'}}> <span>There are no cutting patterns in this job card.</span> </p>
            ))
          ) : (
            <div className="list-grid-view">
              <TableLayoutData>
                <div className="tableDataFormat removePagnation">
                  {cylinderData?.cutting_patterns?.length ? (
                    <Table
                      size="large"
                      style={{
                        minWidth: "100% !important",
                        width: "100% !important",
                      }}
                      columns={cylinderColumnHead}
                      dataSource={dataSet}
                      onChange={onChange}
                      scroll={{
                        x: window.screen.width < 1500,
                      }}
                      pagination={false}
                    />
                  ) : (
                    <p style={{width: '100%', textAlign: 'center'}}>
                      <span> There are no cutting patterns in this job card.</span> 
                    </p>
                  )}
                </div>
              </TableLayoutData>
            </div>
          )}
        </div>
      </PipeDesign>
    </>
  ) : null;
};

export default SheetJobCardCylinderContainerMultistage;
